let scriptPromise = null;

export function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => { scriptPromise = null; resolve(false); };
    document.body.appendChild(s);
  });
  return scriptPromise;
}

// Opens the Razorpay checkout for a created order.
// order = { razorpay_order_id, amount, key_id, prefill }
// Resolves with the payment response on success, rejects on dismiss/failure.
export async function openRazorpayCheckout(order, { name = "Fixigo Home Services", description = "Service Booking" } = {}) {
  const ok = await loadRazorpay();
  if (!ok || !window.Razorpay) throw new Error("Payment gateway failed to load. Check your connection and try again.");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: Math.round(order.amount * 100),
      currency: "INR",
      name,
      description,
      order_id: order.razorpay_order_id,
      prefill: order.prefill || {},
      theme: { color: "#4F46E5" },
      handler: (res) => resolve(res),
      modal: { ondismiss: () => reject(new Error("Payment cancelled")) },
    });
    rzp.on("payment.failed", (resp) => reject(new Error(resp?.error?.description || "Payment failed")));
    rzp.open();
  });
}
